<template>
  <div id="order-detail">
    <div id="order-detail-header">
      <div class="order-detail-username">
        {{ orderStatus }}
      </div>
    </div>

    <div id="order-detail-profile-info">
      <img class="icon" src="../../assets/order_detail_location.png" alt="">
      <div class="address">
        <div class="phone">
          <div class="username">
            {{ userName }}
          </div>
          <div class="tel">
            {{ tel }}
          </div>
        </div>

        <div class="address-info">
          {{ address }}
        </div>
      </div>
    </div>
    <div class="container">
      <div class="sheet-image-info">
        <div class="sheet-image">
          <img :src="baseUrl + imageUrl"/>
        </div>
        <div class="sheet-info">
          <div class="package-name">
            {{ packageName }}
          </div>
          <div class="spec-content">
            <div v-for="(goods, index) in goodsList" :key="index">
              {{ goods.abbreviation }}{{ goods.count }}排
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>

      <div v-if="packageType === PACKAGE_TYPE.HAS_PURCHASE_GOODS">
        <div v-for="(item, index) in packageAddPurchaseList" :key="index">
          <div class="sheet-image-info">
            <div class="sheet-image">
              <img :src="baseUrl + item.goodsImage" alt=""/>
            </div>
            <div class="sheet-info">
              <div class="package-name">加价购商品</div>
              <div class="spec-content">
                <div>{{ item.goodsName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="quantity-container">
        <span class="quantity-label">数量：</span>
        <div class="explain-number">
          <div class="number">
            {{ packageQuantity }}
          </div>
        </div>
      </div>
      <div class="quantity-container">
        <span class="quantity-label">总价：</span>
        <div class="explain-number">
          <div class="number">
            ￥{{ packageTotalPrice }}
          </div>
        </div>
      </div>

      <div class="status">
        <div v-if="orderStatus === '未配送' && !isDelivered " class="cancel-btn" @click="handleCancel">取消订单</div>
        <div v-if="orderStatus === '已配送' " class="cancel-btn" @click="handleFinish">确认收货</div>
        <div>备注：{{ remark }}</div>
        <div v-if="orderStatus === '已取消'">
          <div>取消理由：{{ cancelReason }}</div>
          <div>取消端：{{ cancelEnd }}</div>
        </div>
      </div>

      <div id="order-detail-info">
        <div>订单编号：{{ orderNumber }}</div>
        <div>下单时间：{{ orderTime }}</div>
        <div v-if="orderStatus === '已完成'">
          完成配送时间：{{ deliverTime }}
        </div>
        <div v-else-if="orderStatus === '已取消'">
          <div>取消时间：{{ statusTime }}</div>

          <div v-if="isDelivered">
            <div style="position: relative; top: -10px;" @click="callPhone(distributionTle)">
              配送中心电话：{{ distributionTle }}
              <img style="width: 30px;position: relative; top: 5px" src="../../assets/phone.png">
            </div>
          </div>
          <div v-else>
            <div>配送中心电话：暂无配送中心信息</div>
          </div>
        </div>
        <div v-else-if="orderStatus === '已配送'">
          完成配送时间： {{ deliverTime }}
          <div style="position: relative; top: -10px;" @click="callPhone(distributionTle)">
            配送中心电话：{{ distributionTle }}
            <img style="width: 30px;position: relative; top: 5px" src="../../assets/phone.png">
          </div>
        </div>
        <div v-if="orderStatus === '未配送' && isDelivered">
          <div>预计配送时间：{{ forecastDeliverTime }}</div>
          <div>提示：已为该订单分配益力多姐姐，如要取消订单请联系</div>
          <div style="position: relative; top: -10px;" @click="callPhone(distributionTle)">
            配送中心电话：{{ distributionTle }}
            <img style="width: 30px;position: relative; top: 5px" src="../../assets/phone.png">
          </div>
        </div>
        <div v-else-if="orderStatus === '未配送'">
          <div>配送中心电话：暂无配送中心信息</div>
        </div>


      </div>
      <div class="back-btn" @click="backBtn">返回</div>

      <base-dialog v-if="messageVisible" :title="title" display="none" width="80%" @close="close">
        <div class="order-cancel-reason">
          <div class="canceled-title">取消订单</div>
          <div style="text-align: left">请选择取消理由</div>
          <div class="radio-box" v-for="(item,index) in radios" :key="item.id">
            <span class="radio" :class="{'on':item.isChecked}"></span>
            <input v-model="reason" :value="item.value" class="input-radio" :checked='item.isChecked'
                   @click="check(index)" type="radio">{{ item.label }}
          </div>
          <input class="other-reason" type="text" v-model="otherReason" v-show="isOtherReason"/>
        </div>
        <div class="dialog-cancel" @click="close">取消</div>
        <button class="dialog-ok" @click="requestCancelOrder" :disable="cancelBtnDisable">确定</button>
      </base-dialog>

      <base-dialog v-if="finishedVisible" :title="finishedTitle" display="none" width="80%" @close="close">
        <p style="padding: 1.5rem 0; font-size: 1rem">是否确认收货?</p>
        <div class="dialog-btn" style="float: left;" @click="close">取消</div>
        <button class="dialog-btn" style="float: right;" @click="requestConfirmPackagePeriodOrder"
                :disabled="btnDisable">
          确定
        </button>
      </base-dialog>

      <div class="toast" v-show="toastShow">
        {{ toastText }}
      </div>
    </div>
  </div>
</template>

<script>
import {CancelPackagePeriodOrder, ConfirmPackagePeriodOrder, GetPackagePeriodOrder} from "@/api/PackagePeriodOrder";
import {numFilter, parseTime, starPhone} from "@/unitls";
import BaseDialog from "@/components/BaseDialog";
import {BASE_URL} from "@/config/app";
import {PACKAGE_TYPE} from "../../store/mutation-types";

export default {
  name: "PackageOrderDetail",
  components: {BaseDialog},
  data() {
    return {
      id: this.$route.query.orderId,
      orderStatus: this.$route.query.status,
      userName: '',
      tel: '',
      address: '',
      orderNumber: '',
      remark: '',
      cancelReason: '',
      cancelEnd: '',
      orderTime: '',
      statusTime: '',
      deliverTime: '',
      forecastDeliverTime: '',
      distributionTle: '',
      isDelivered: false,
      totalPrice: 0,
      goodsList: [],

      title: '取消理由',
      messageVisible: false,
      message: "",

      finishedTitle: '确认收货',
      finishedVisible: false,


      toastShow: false,
      toastText: '',

      isOrderOk: false,

      reason: '发货太慢',
      otherReason: '',
      isOtherReason: false,

      radios: [
        {
          label: '发货太慢',
          value: '发货太慢',
          isChecked: true,
        },
        {
          label: '现在不想购买',
          value: '现在不想购买',
          isChecked: false,
        },
        {
          label: '重复下单',
          value: '重复下单',
          isChecked: false,
        },
        {
          label: '收货人信息有误',
          value: '收货人信息有误',
          isChecked: false,
        },
        {
          label: '其他原因',
          value: '其他原因',
          isChecked: false,
        },
      ],

      btnDisable: false,
      cancelBtnDisable: false,
      packageOrderNumber: '',
      packageType: PACKAGE_TYPE.NO_PURCHASE_GOODS,
      packageAddPurchaseList: [],
      preferentialPrice: 0,
      packageQuantity: 1,
      imageUrl: '',
      packageName: '',
      packageTotalPrice: 0,
      baseUrl: BASE_URL
    }
  },

  mounted() {
    this.requestOrderDetail();
  },

  computed: {
    PACKAGE_TYPE() {
      return PACKAGE_TYPE
    },
  },

  methods: {
    //套餐每期订单确认收货
    requestConfirmPackagePeriodOrder() {
      this.btnDisable = true;
      ConfirmPackagePeriodOrder(
          this.id
      ).then(res => {
        if (res.code === this.$API_CODE.OK) {
          this.finishedVisible = false;
          this.toast('收货成功');
          this.$emit('close');
          this.isOrderOk = true;
        } else {
          this.finishedVisible = false;
          this.toast(res.message);
          this.btnDisable = false;
        }
      })
    },
    //设置取消理由
    check(index) {
      // 先取消所有选中项
      this.radios.forEach((item) => {
        item.isChecked = false;
      });
      //再设置当前点击项选中
      this.reason = this.radios[index].label;
      if (this.radios[index].value === '其他原因') {
        this.isOtherReason = true;
      } else {
        this.isOtherReason = false;
      }
      // 设置值，以供传递
      this.radios[index].isChecked = true;
    },


    close() {
      this.messageVisible = false;
      this.finishedVisible = false;
      this.$emit('close');
    },

    toast(e) {
      let _that = this;
      this.toastText = e;
      this.toastShow = true;
      setTimeout(function () {
        _that.toastShow = false;
        if (_that.isOrderOk) {
          _that.$router.go(-1);
        }
      }, 1500)
    },
    // 获取订单详情
    requestOrderDetail() {
      GetPackagePeriodOrder({
        packagePeriodOrderId: this.id
      })
          .then((response) => {

            if (response.code === this.$API_CODE.OK) {
              this.userName = response.data.consignee;
              this.tel = starPhone(response.data.mobile);
              this.address = response.data.area + response.data.address;
              this.orderNumber = response.data.orderNumber;
              this.remark = response.data.remark;
              this.cancelReason = response.data.orderCancelReason;
              this.statusTime = parseTime(response.data.cancelledAt);
              this.deliverTime = parseTime(response.data.deliveredAt);
              this.forecastDeliverTime = response.data.forecastDeliverTime;
              this.orderTime = parseTime(response.data.createdAt);
              this.cancelEnd = this.formatStatus(response.data.orderCancelClient);
              this.packageOrderNumber = response.data.packageNumber;
              this.packageType = response.data.packageType;
              this.packageAddPurchaseList = response.data.packageAddPurchaseList;
              this.preferentialPrice = response.data.preferentialPrice;
              this.packageQuantity = response.data.packageQuantity;
              this.imageUrl = response.data.imageUrl;
              this.packageName = response.data.packageName;
              this.packageTotalPrice = response.data.packageTotalPrice;

              if (response.data.deliverStatus == 2) {
                this.isDelivered = true;
                this.distributionTle = response.data.distributionCenterTel;
              }
              this.totalPrice = numFilter(response.data.totalPrice);

              response.data.goodsList.forEach((item) => {
                this.goodsList.push({
                  id: item.goodsId,
                  goodsName: item.name,
                  count: item.number,
                  goodsPrice: item.price,
                  imageUrl: BASE_URL + item.imageUrl,
                  abbreviation: item.abbreviation
                });
              });
            }
          })
    },

    handleCancel() {
      this.messageVisible = true;
    },
    handleFinish() {
      this.finishedVisible = true;
    },
    requestCancelOrder() {
      let orderCancelReason = '';

      if (this.reason === '其他原因') {
        orderCancelReason = this.otherReason
      } else {
        orderCancelReason = this.reason
      }
      this.cancelBtnDisable = true;
      CancelPackagePeriodOrder(
          {
            packagePeriodOrderId: this.id,
            cancelRemark: orderCancelReason
          }
      ).then((response) => {
        if (response.code === this.$API_CODE.OK) {
          /*localStorage.setItem('remainTotal', response.data);
          console.log("data================",response.data)*/
          this.messageVisible = false;
          this.toast('订单取消成功');
          this.$emit('close');
          this.isOrderOk = true;
        } else {
          this.messageVisible = false;
          this.toast(response.message);
          this.cancelBtnDisable = false;
        }

      })
    },

    formatStatus(value) {
      return value === this.$ORDERS_CANCEL.MEMBER ? '用户端' : value === this.$ORDERS_CANCEL.LADY ? '益力多姐姐端' : value === this.$ORDERS_CANCEL.DISTRIBUTION_CENTER ? '配送中心端' : '用户端';

    },

    callPhone(tel) {
      window.location.href = 'tel://' + tel;
    },

    backBtn() {
      this.$router.go(-1);
    }
  },
}
</script>

<style scoped lang="scss">

* {
  margin: 0;
  padding: 0;
}

#order-detail {
  background: #fdf9f7;
  width: auto;
  height: auto;
  overflow-y: auto;
  top: 0;
  left: 0;
  padding-bottom: 60px;
  //header
  #order-detail-header {
    width: auto;
    height: 6rem;
    background: url("../../assets/detail.png");
    background-size: 100% 6rem;

    .order-detail-icon {
      width: 39px;
      height: 57px;
      float: left;
      margin-left: 30px;
      line-height: 6rem;
    }

    .order-detail-username {
      float: right;
      line-height: 6rem;
      margin-right: 30px;
      color: white;
      font-size: 1rem;
      font-weight: bold;
    }
  }

  //个人详细信息
  #order-detail-profile-info {
    height: 80px;
    padding-top: 15px;
    padding-right: 10px;
    text-align: center;
    background: #FFFFFF;
    //定位图标
    .icon {
      float: left;
      margin-top: 8px;
      margin-left: 20px;
    }

    //用户信息及详细地址
    .address {
      .phone {
        .username {
          font-size: 0.8rem;
          margin-left: 15px;
          float: left;
        }

        .tel {
          font-size: 0.9rem;
          text-align: left;
          text-indent: 4em;
        }
      }

      .address-info {
        font-size: 0.8rem;
        text-align: left;
        margin-left: 50px;
      }
    }


  }

  #order-detail-info {
    padding-top: 10px;
    margin-top: 20px;
    padding-left: 30px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    background: #FFFFFF;
    text-align: left;
    font-size: 0.9rem;
    line-height: 25px;
  }

  .clear {
    clear: both;
  }

  .order-cancel-reason {
    text-align: left;
    margin-bottom: 10px;

    .canceled-title {
      color: #ea2d53;
      text-align: center;
      font-size: 1rem;
      font-weight: bold;
      padding: 5px 0;
    }

    .cancel-radio {
      line-height: 30px;
    }

    .other-reason {
      border: 1px solid #495060;
      width: 100%;
      padding: 10px;
      height: 50px;
      border-radius: 5px;
      margin-bottom: 10px;
    }

    .radio-box {
      display: inline-block;
      position: relative;
      height: 25px;
      line-height: 25px;
      width: 50%;
      text-align: left;
      margin: 5px 0;
    }

    .input-radio {
      display: inline-block;
      position: absolute;
      opacity: 0;
      width: 100%;
      height: 25px;
      left: 0px;
      outline: none;
      -webkit-appearance: none;
    }

    .radio {
      display: inline-block;
      width: 22px;
      height: 22px;
      vertical-align: middle;
      background-image: url(../../assets/checkbox_off.png);
      background-repeat: no-repeat;
      //background-position: 0 0;
      background-size: 100% 100%;
      margin-top: -5px;
      margin-right: 5px;
    }

    .on {
      width: 22px;
      height: 22px;
      background-image: url(../../assets/checkbox_on.png);
      background-size: 100% 100%;
    }
  }

  .dialog-ok {
    float: right;
    width: 45%;
    color: #ffffff;
    padding: 10px 0;
    background: #ea2d53;
    border-radius: 5px;
    border: none;
  }

  .dialog-cancel {
    float: left;
    width: 45%;
    color: #ffffff;
    padding: 10px 0;
    background: #ea2d53;
    border-radius: 5px;
  }

  .back-btn {
    margin: auto;
    width: 80%;
    font-size: 1rem;
    //font-weight: bold;
    color: #ea2d53;
    border: 1px solid #ea2d53;
    border-radius: 5px;
    padding: 10px;
  }
}

.dialog-btn {
  /*float: left;*/
  width: 45%;
  color: #ffffff;
  padding: 10px 0;
  background: #ea2d53;
  border-radius: 5px;
  border: none;
}

@media screen and (max-width: 320px) {
  #order-detail {

    .order-cancel-reason {
      text-align: left;
      margin-bottom: 10px;


      .radio-box {
        display: inline-block;
        position: relative;
        height: 25px;
        line-height: 25px;
        width: 100%;
        text-align: left;
        margin: 5px 0;
      }
    }


  }
}

.container {
  background: #ffffff;
}

.sheet-image-info {
  width: 100%;
  position: relative;
  display: flex;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  margin: 10px 0;

  .sheet-image {
    width: 33.33%;
    display: flex;
    align-items: center;

    img {
      width: 15vh;
      height: 15vh;
    }
  }

  .sheet-info {
    width: 66.67%;
    padding-left: 10px;

    .package-name {
      font-size: 18px;
      text-align: left;
      margin-bottom: 10px;
      color: #ea2d53;
    }
  }
}

.spec-content {
  padding: 10px 0;
  font-size: 14px;
  text-align: left;

  div {
    margin-bottom: 5px;
  }
}

.quantity-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;

  .quantity-label {
    font-size: 23px;
    color: #ea2d53;
    margin-right: 10px;
  }

  .explain-number {

    .number {
      width: 120px;
      height: 33px;
      float: left;
      line-height: 33px;
      text-align: center;
      font-weight: bold;
      font-size: 23px;
      color: #ea2d53;

      &.disabled {
        background-color: #f5f5f5;
        color: #cccccc;
        border-color: #cccccc;
      }
    }
  }
}

.status {
  text-align: left;
  margin-top: 20px;
  margin-left: 30px;
  font-size: 0.9rem;

  .add-purchase-goods {
    margin-bottom: 20px;
  }

  .add-purchase-goods-list {
    display: flex;
    flex-wrap: wrap;
  }

  .add-purchase-goods-item {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .add-purchase-goods-image {
    width: 40px;
    height: 40px;
    margin-left: 5px;
  }

  .cancel-btn {
    float: right;
    margin-right: 10px;
    padding: 5px 10px;
    //color: #ea2d53;
    //border: 1px solid #ea2d53;
    //border-radius: 5px;
    background-color: #fdf9f7;
    border: 1px solid #ea2d53;
    color: #ea2d53;
    font-size: 0.9rem;
    margin-top: -10px;
  }
}

</style>